"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringify = exports.filterProps = exports.filterObject = exports.whitelist = exports.shallowMerge = exports.omitNils = exports.mapValue = exports.isObject = exports.isFlat = exports.hasKeys = exports.hasKey = exports.deepMerge = exports.mergeAll = exports.merge = exports.blacklist = exports.areEmpty = exports.isEmpty = void 0;

var General = _interopRequireWildcard(require("../General"));

var Classify = _interopRequireWildcard(require("../Classify"));

var Logic = _interopRequireWildcard(require("../Logic"));

var Arrays = _interopRequireWildcard(require("../Arrays"));

var Strings = _interopRequireWildcard(require("../Strings"));

var Numbers = _interopRequireWildcard(require("../Numbers"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var isEmpty = function isEmpty(obj) {
  return Object.keys(obj).length === 0;
};

exports.isEmpty = isEmpty;

var areEmpty = function areEmpty(keys) {
  return function (obj) {
    return keys.every(function (key) {
      return Object.prototype.hasOwnProperty.call(obj, key);
    }) && keys.every(function (key) {
      return Logic.caseOf({
        Array: Arrays.isEmpty,
        Object: isEmpty,
        String: Strings.isEmpty,
        Number: Numbers.isEmpty,
        defaultCase: function defaultCase() {
          return true;
        }
      })(Classify.typeOf)(obj[key]);
    });
  };
};

exports.areEmpty = areEmpty;

var merge = function merge(first) {
  return function (second) {
    var partial = Object.entries(first).reduce(function (acc, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      if (!Object.prototype.hasOwnProperty.call(second, key)) {
        acc[key] = value;
      } else {
        acc[key] = General.merge(first[key])(second[key]);
      }

      return acc;
    }, {});
    return Object.entries(second).reduce(function (acc, _ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];

      if (!Object.prototype.hasOwnProperty.call(first, key)) {
        acc[key] = value;
      }

      return acc;
    }, partial);
  };
};

exports.merge = merge;

var isObject = function isObject(value) {
  return Classify.is('Object')(value);
};

exports.isObject = isObject;

var deepMerge = function deepMerge() {
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }

  return objects.reduce(function (result, current) {
    Object.keys(current).forEach(function (key) {
      if (Array.isArray(result[key]) && Array.isArray(current[key])) {
        result[key] = Array.from(new Set(result[key].concat(current[key])));
      } else if (isObject(result[key]) && isObject(current[key])) {
        result[key] = deepMerge(result[key], current[key]);
      } else {
        result[key] = current[key];
      }
    });
    return result;
  }, {});
};

exports.deepMerge = deepMerge;

var mergeAll = function mergeAll(objs) {
  return objs.reduce(function (acc, obj) {
    return Object.entries(obj).reduce(function (acc_, _ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          value = _ref6[1];

      if (Object.prototype.hasOwnProperty.call(acc_, key)) {
        acc_[key] = General.merge(acc_[key])(value);
        return acc_;
      }

      acc_[key] = value;
      return acc;
    }, acc);
  }, {});
};

exports.mergeAll = mergeAll;

var hasKey = function hasKey(key) {
  return function (obj) {
    return Object.prototype.hasOwnProperty.call(obj, key);
  };
};

exports.hasKey = hasKey;

var hasKeys = function hasKeys(keys) {
  return function (obj) {
    return keys.every(function (key) {
      return Object.prototype.hasOwnProperty.call(obj, key);
    });
  };
};

exports.hasKeys = hasKeys;

var isFlat = function isFlat(obj) {
  return Object.values(obj).every(function (value) {
    return _typeof(value) !== 'object';
  });
};

exports.isFlat = isFlat;

var mapValue = function mapValue(key) {
  return function (mapper) {
    return function (obj) {
      return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, key, mapper(obj[key])(obj)));
    };
  };
};

exports.mapValue = mapValue;

var omitNils = function omitNils(obj) {
  return Object.entries(obj).reduce(function (acc, _ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        key = _ref8[0],
        value = _ref8[1];

    Logic.caseOf({
      Array: function (_Array) {
        function Array(_x) {
          return _Array.apply(this, arguments);
        }

        Array.toString = function () {
          return _Array.toString();
        };

        return Array;
      }(function (arr) {
        acc[key] = Arrays.omitNils(arr);
        return acc;
      }),
      Null: function Null() {
        return acc;
      },
      Object: function Object(obj_) {
        acc[key] = omitNils(obj_);
        return acc;
      },
      Undefined: function Undefined() {
        return acc;
      },
      defaultCase: function defaultCase() {
        acc[key] = value;
        return acc;
      }
    })(Classify.typeOf)(value);
    return acc;
  }, {});
};

exports.omitNils = omitNils;

var filterObject = function filterObject(predicate) {
  return function (object) {
    var filteredValues = Object.keys(object).filter(function (key) {
      return predicate(object[key], key);
    }).map(function (key) {
      return _defineProperty({}, key, object[key]);
    });
    return Object.assign.apply(Object, [{}].concat(_toConsumableArray(filteredValues)));
  };
};

exports.filterObject = filterObject;

var filterProps = function filterProps(propsToFilterOut) {
  return filterObject(function (value, key) {
    return propsToFilterOut.indexOf(key) === -1;
  });
};

exports.filterProps = filterProps;

var shallowMerge = function shallowMerge(objs) {
  return objs.reduce(function (acc, obj) {
    return _objectSpread(_objectSpread({}, acc), obj);
  }, {});
};

exports.shallowMerge = shallowMerge;

var whitelist = function whitelist(keysToKeep) {
  return function (obj) {
    return keysToKeep.reduce(function (acc, key) {
      var value = obj[key];

      if (key in obj) {
        acc[key] = value;
      }

      return acc;
    }, {});
  };
};

exports.whitelist = whitelist;

var blacklist = function blacklist(keysToBlacklist) {
  return function (obj) {
    var result = Object.entries(obj).reduce(function (acc, _ref10) {
      var _ref11 = _slicedToArray(_ref10, 2),
          key = _ref11[0],
          value = _ref11[1];

      if (!keysToBlacklist.includes(key)) {
        acc[key] = value;
      }

      return acc;
    }, {});

    if (isFlat(result)) {
      return result;
    }

    return Object.entries(result).reduce(function (acc, _ref12) {
      var _ref13 = _slicedToArray(_ref12, 2),
          key = _ref13[0],
          value = _ref13[1];

      if (isObject(value)) {
        acc[key] = blacklist(keysToBlacklist)(value);
      } else {
        acc[key] = value;
      }

      return acc;
    }, {});
  };
};

exports.blacklist = blacklist;

var stringify = function stringify(o) {
  if (o !== null) {
    if (typeof o === 'string') {
      return o;
    }

    return JSON.stringify(o);
  }

  return '';
};

exports.stringify = stringify;
//# sourceMappingURL=index.js.map